import React from 'react';
import FormComponent from '../FormComponent';
import { useDispatch, useSelector } from 'react-redux';
import {
  returnCategoriesDropdownList,
  returnCompaniesDropdownList,
} from '../../../../utils/products';
import { vendorUserschema } from '../../schema/vendorUser';
import { addNewBrandVendorUser } from '../../../../parse-functions/sms/addUsers';
import { updateToastInfo } from '../../../../actions/settings';
import { useTranslation } from 'react-i18next';
import { updateSpinnerState } from '../../../../actions/spinner';
import { arrayToDropdownOptions } from '../../../../utils/sms/arrayToDropdownOptions';
import { editVendorUserSchema } from '../../schema/userEdit';
import { transformFormData } from '../../../../utils/sms/convertProductsToDropdownOptions';

const AddVendorUser = ({ editData, handleSave }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const companies = useSelector((state) => state?.products?.companies || {});
  const categories = useSelector((state) => state?.products?.categories || {});
  const isBrandManager = useSelector(
    (state) => state?.user?.preferences?.isBrandManager || false
  );
  const isAdmin = useSelector(
    (state) => state?.user?.preferences?.isAdmin || false
  );
  const userInfo = useSelector((state) => state?.user?.userInfo);
  let schema = editData ? editVendorUserSchema : vendorUserschema;

  schema = schema.map((section) =>
    section.map((field) => {
      if (field.id === 'company' && !isBrandManager) {
        field.options = returnCompaniesDropdownList(companies);
      } else if (field.id === 'company') {
        field.options = arrayToDropdownOptions(userInfo?.company || []);
      }
      if (
        field.title === 'Category' &&
        !isBrandManager &&
        Object.keys(categories).length > 0
      ) {
        field.options = [
          { label: 'All', value: 'All' },
          ...returnCategoriesDropdownList(categories),
        ];
      } else if (field.title === 'Category') {
        field.options = arrayToDropdownOptions(userInfo?.productCategory || []);
      }
      return field;
    })
  );

  const saveVendorUser = async (formData, callback) => {
    try {
      dispatch(updateSpinnerState(true));
      formData = transformFormData({
        formData,
        categories,
        userInfo,
        isAdmin,
      });
      if (editData) {
        handleSave(formData);
      } else {
        await addNewBrandVendorUser({ ...formData, applications: ['sms'] });
      }
      dispatch(
        updateToastInfo({
          show: true,
          type: 'success',
          title: t('User Added'),
          message: editData
            ? t(`${formData.name} updated successfully`)
            : t(`${formData.userName} added successfully`),
        })
      );
      callback(null);
    } catch (error) {
      const { message } = error;
      dispatch(
        updateToastInfo({
          show: true,
          type: 'danger',
          title: editData ? t('User Edit failed') : t('User Add Failed'),
          message: editData
            ? t(`${formData.name} failed to edit`)
            : t(`${formData.userName} failed to add`),
        })
      );
      callback(message);
    }
    dispatch(updateSpinnerState(false));
  };
  return (
    <div>
      <div>
        <FormComponent
          schema={schema}
          savefunction={saveVendorUser}
          editData={editData}
        />
      </div>
    </div>
  );
};

export default AddVendorUser;
